function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
/**
 * Read a ref's current value and reset it to `null` in one expression. Borrowed from C++'s
 * `std::move`: useful when you want to "consume" a ref's value, ensuring it can't be used again.
 *
 * Note that `take` does not enforce non-null. Use `!` at the call site when you've already
 * established that the ref is set.
 *
 * @example
 * ```ts
 * const el = take(pendingPointerCaptureEl)!
 * // pendingPointerCaptureEl.current is now null; el is the previous value
 * ```
 */
function take(ref) {
    const value = ref.current;
    ref.current = null;
    return value;
}

export { setRef, take };
//# sourceMappingURL=ref.js.map
